"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6111],{

/***/ 71723:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ landing_Press; }
});

// EXTERNAL MODULE: ./components/landing/ContactUsForm.jsx
var ContactUsForm = __webpack_require__(60650);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/format/index.js + 32 modules
var format = __webpack_require__(13524);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/datamynt-ui-library/lib/index.esm.js
var index_esm = __webpack_require__(21627);
;// CONCATENATED MODULE: ./contexts/Landing/actions.js
var setArticlePage = function setArticlePage(dispatch, value) {
  dispatch({
    type: "SET_ARTICLE_PAGE",
    value: value
  });
};
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./contexts/Landing/index.js
var Landing = __webpack_require__(493);
;// CONCATENATED MODULE: ./node_modules/react-share/es/utils/assert.js
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var AssertionError = /** @class */ (function (_super) {
    __extends(AssertionError, _super);
    function AssertionError(message) {
        var _this = _super.call(this, message) || this;
        _this.name = 'AssertionError';
        return _this;
    }
    return AssertionError;
}(Error));
function assert(value, message) {
    if (!value) {
        throw new AssertionError(message);
    }
}

;// CONCATENATED MODULE: ./node_modules/react-share/es/utils/objectToGetParams.js
function objectToGetParams(object) {
    var params = Object.entries(object)
        .filter(function (_a) {
        var value = _a[1];
        return value !== undefined && value !== null;
    })
        .map(function (_a) {
        var key = _a[0], value = _a[1];
        return "".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(String(value)));
    });
    return params.length > 0 ? "?".concat(params.join('&')) : '';
}

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./node_modules/react-share/es/ShareButton.js
var ShareButton_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};


var isPromise = function (obj) {
    return !!obj && (typeof obj === 'object' || typeof obj === 'function') && typeof obj.then === 'function';
};
var getBoxPositionOnWindowCenter = function (width, height) { return ({
    left: window.outerWidth / 2 + (window.screenX || window.screenLeft || 0) - width / 2,
    top: window.outerHeight / 2 + (window.screenY || window.screenTop || 0) - height / 2,
}); };
var getBoxPositionOnScreenCenter = function (width, height) { return ({
    top: (window.screen.height - height) / 2,
    left: (window.screen.width - width) / 2,
}); };
function windowOpen(url, _a, onClose) {
    var height = _a.height, width = _a.width, configRest = __rest(_a, ["height", "width"]);
    var config = __assign({ height: height, width: width, location: 'no', toolbar: 'no', status: 'no', directories: 'no', menubar: 'no', scrollbars: 'yes', resizable: 'no', centerscreen: 'yes', chrome: 'yes' }, configRest);
    var shareDialog = window.open(url, '', Object.keys(config)
        .map(function (key) { return "".concat(key, "=").concat(config[key]); })
        .join(', '));
    if (onClose) {
        var interval_1 = window.setInterval(function () {
            try {
                if (shareDialog === null || shareDialog.closed) {
                    window.clearInterval(interval_1);
                    onClose(shareDialog);
                }
            }
            catch (e) {
                /* eslint-disable no-console */
                console.error(e);
                /* eslint-enable no-console */
            }
        }, 1000);
    }
    return shareDialog;
}
var ShareButton = /** @class */ (function (_super) {
    ShareButton_extends(ShareButton, _super);
    function ShareButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.openShareDialog = function (link) {
            var _a = _this.props, onShareWindowClose = _a.onShareWindowClose, _b = _a.windowHeight, windowHeight = _b === void 0 ? 400 : _b, _c = _a.windowPosition, windowPosition = _c === void 0 ? 'windowCenter' : _c, _d = _a.windowWidth, windowWidth = _d === void 0 ? 550 : _d;
            var windowConfig = __assign({ height: windowHeight, width: windowWidth }, (windowPosition === 'windowCenter'
                ? getBoxPositionOnWindowCenter(windowWidth, windowHeight)
                : getBoxPositionOnScreenCenter(windowWidth, windowHeight)));
            windowOpen(link, windowConfig, onShareWindowClose);
        };
        _this.handleClick = function (event) { return __awaiter(_this, void 0, void 0, function () {
            var _a, beforeOnClick, disabled, networkLink, onClick, url, openShareDialogOnClick, opts, link, returnVal;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.props, beforeOnClick = _a.beforeOnClick, disabled = _a.disabled, networkLink = _a.networkLink, onClick = _a.onClick, url = _a.url, openShareDialogOnClick = _a.openShareDialogOnClick, opts = _a.opts;
                        link = networkLink(url, opts);
                        if (disabled) {
                            return [2 /*return*/];
                        }
                        event.preventDefault();
                        if (!beforeOnClick) return [3 /*break*/, 2];
                        returnVal = beforeOnClick();
                        if (!isPromise(returnVal)) return [3 /*break*/, 2];
                        return [4 /*yield*/, returnVal];
                    case 1:
                        _b.sent();
                        _b.label = 2;
                    case 2:
                        if (openShareDialogOnClick) {
                            this.openShareDialog(link);
                        }
                        if (onClick) {
                            onClick(event, link);
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        return _this;
    }
    ShareButton.prototype.render = function () {
        var _a = this.props, beforeOnClick = _a.beforeOnClick, children = _a.children, className = _a.className, disabled = _a.disabled, disabledStyle = _a.disabledStyle, forwardedRef = _a.forwardedRef, networkLink = _a.networkLink, networkName = _a.networkName, onShareWindowClose = _a.onShareWindowClose, openShareDialogOnClick = _a.openShareDialogOnClick, opts = _a.opts, resetButtonStyle = _a.resetButtonStyle, style = _a.style, url = _a.url, windowHeight = _a.windowHeight, windowPosition = _a.windowPosition, windowWidth = _a.windowWidth, rest = __rest(_a, ["beforeOnClick", "children", "className", "disabled", "disabledStyle", "forwardedRef", "networkLink", "networkName", "onShareWindowClose", "openShareDialogOnClick", "opts", "resetButtonStyle", "style", "url", "windowHeight", "windowPosition", "windowWidth"]);
        var newClassName = classnames_default()('react-share__ShareButton', {
            'react-share__ShareButton--disabled': !!disabled,
            disabled: !!disabled,
        }, className);
        var newStyle = resetButtonStyle
            ? __assign(__assign({ backgroundColor: 'transparent', border: 'none', padding: 0, font: 'inherit', color: 'inherit', cursor: 'pointer' }, style), (disabled && disabledStyle)) : __assign(__assign({}, style), (disabled && disabledStyle));
        return (react.createElement("button", __assign({}, rest, { "aria-label": rest['aria-label'] || networkName, className: newClassName, onClick: this.handleClick, ref: forwardedRef, style: newStyle }), children));
    };
    ShareButton.defaultProps = {
        disabledStyle: { opacity: 0.6 },
        openShareDialogOnClick: true,
        resetButtonStyle: true,
    };
    return ShareButton;
}(react.Component));
/* harmony default export */ var es_ShareButton = (ShareButton);

;// CONCATENATED MODULE: ./node_modules/react-share/es/hocs/createShareButton.js
var createShareButton_assign = (undefined && undefined.__assign) || function () {
    createShareButton_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return createShareButton_assign.apply(this, arguments);
};


function createShareButton(networkName, link, optsMap, defaultProps) {
    function CreatedButton(props, ref) {
        var opts = optsMap(props);
        var passedProps = createShareButton_assign({}, props);
        // remove keys from passed props that are passed as opts
        var optsKeys = Object.keys(opts);
        optsKeys.forEach(function (key) {
            delete passedProps[key];
        });
        return (react.createElement(es_ShareButton, createShareButton_assign({}, defaultProps, passedProps, { forwardedRef: ref, networkName: networkName, networkLink: link, opts: optsMap(props) })));
    }
    CreatedButton.displayName = "ShareButton-".concat(networkName);
    return (0,react.forwardRef)(CreatedButton);
}
/* harmony default export */ var hocs_createShareButton = (createShareButton);

;// CONCATENATED MODULE: ./node_modules/react-share/es/FacebookShareButton.js



function facebookLink(url, _a) {
    var quote = _a.quote, hashtag = _a.hashtag;
    assert(url, 'facebook.url');
    return ('https://www.facebook.com/sharer/sharer.php' +
        objectToGetParams({
            u: url,
            quote: quote,
            hashtag: hashtag,
        }));
}
var FacebookShareButton = hocs_createShareButton('facebook', facebookLink, function (props) { return ({
    quote: props.quote,
    hashtag: props.hashtag,
}); }, {
    windowWidth: 550,
    windowHeight: 400,
});
/* harmony default export */ var es_FacebookShareButton = (FacebookShareButton);

;// CONCATENATED MODULE: ./node_modules/react-share/es/LinkedinShareButton.js



function linkedinLink(url, _a) {
    var title = _a.title, summary = _a.summary, source = _a.source;
    assert(url, 'linkedin.url');
    return ('https://linkedin.com/shareArticle' +
        objectToGetParams({ url: url, mini: 'true', title: title, summary: summary, source: source }));
}
var LinkedinShareButton = hocs_createShareButton('linkedin', linkedinLink, function (_a) {
    var title = _a.title, summary = _a.summary, source = _a.source;
    return ({ title: title, summary: summary, source: source });
}, {
    windowWidth: 750,
    windowHeight: 600,
});
/* harmony default export */ var es_LinkedinShareButton = (LinkedinShareButton);

;// CONCATENATED MODULE: ./node_modules/react-share/es/TelegramShareButton.js



function telegramLink(url, _a) {
    var title = _a.title;
    assert(url, 'telegram.url');
    return ('https://telegram.me/share/url' +
        objectToGetParams({
            url: url,
            text: title,
        }));
}
var TelegramShareButton = hocs_createShareButton('telegram', telegramLink, function (props) { return ({
    title: props.title,
}); }, {
    windowWidth: 550,
    windowHeight: 400,
});
/* harmony default export */ var es_TelegramShareButton = (TelegramShareButton);

;// CONCATENATED MODULE: ./node_modules/react-share/es/TwitterShareButton.js



function twitterLink(url, _a) {
    var title = _a.title, via = _a.via, _b = _a.hashtags, hashtags = _b === void 0 ? [] : _b, _c = _a.related, related = _c === void 0 ? [] : _c;
    assert(url, 'twitter.url');
    assert(Array.isArray(hashtags), 'twitter.hashtags is not an array');
    assert(Array.isArray(related), 'twitter.related is not an array');
    return ('https://twitter.com/share' +
        objectToGetParams({
            url: url,
            text: title,
            via: via,
            hashtags: hashtags.length > 0 ? hashtags.join(',') : undefined,
            related: related.length > 0 ? related.join(',') : undefined,
        }));
}
var TwitterShareButton = hocs_createShareButton('twitter', twitterLink, function (props) { return ({
    hashtags: props.hashtags,
    title: props.title,
    via: props.via,
    related: props.related,
}); }, {
    windowWidth: 550,
    windowHeight: 400,
});
/* harmony default export */ var es_TwitterShareButton = (TwitterShareButton);

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/landing/Press.jsx











function Press(_ref) {
  var item = _ref.item,
      children = _ref.children;

  var _useContext = (0,react.useContext)(Landing/* LandingContext */.c),
      articlePage = _useContext.state.articlePage,
      dispatch = _useContext.dispatch;

  (0,react.useEffect)(function () {
    setArticlePage(dispatch, true);
  }, [dispatch, articlePage]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "w-full h-full flex items-center flex-col justify-center",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "w-full lg:w-4/5 space-y-4 p-8",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
        href: "/press",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          className: "text-gray-50 text-sm",
          children: "< Datamynt Blog"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h5", {
        children: item["heading"]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "w-full flex justify-between md:-ml-4",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* UserInfo */.ao, {
          width: 40,
          height: 40,
          name: item["author"],
          mail: (0,format/* default */.Z)(new Date(item["date"]), "MMMM dd, yyyy")
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
          className: "flex space-x-4 items-center  md:-ml-4",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
            children: "Share on:"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(es_FacebookShareButton, {
              url: item["link"],
              className: "flex items-center cursor-pointer",
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
                width: "30",
                height: "30",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
                  d: "M15 30c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15C6.716 0 0 6.716 0 15c0 8.284 6.716 15 15 15Z",
                  fill: "#3D8ECD"
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
                  d: "M19.962 4.451h-3.36c-2.003 0-4.229.846-4.229 3.739v3.071H10.06v3.672h2.38v10.594h4.385V14.844h2.893l.267-3.627h-3.227v-2.07c0-1.135 1.202-1.09 1.269-1.09h1.958l-.022-3.606Z",
                  fill: "#fff"
                })]
              })
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(es_LinkedinShareButton, {
              url: item["link"],
              className: "flex items-center cursor-pointer",
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
                width: "30",
                height: "30",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
                  d: "M15 30c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15C6.716 0 0 6.716 0 15c0 8.284 6.716 15 15 15Z",
                  fill: "#3D8ECD"
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
                  d: "M10.348 23.168V12.129H6.676v11.039h3.672ZM8.5 10.638c1.268 0 2.07-.846 2.07-1.914-.023-1.09-.802-1.914-2.048-1.914s-2.07.823-2.07 1.914c0 1.068.801 1.914 2.025 1.914h.023Zm3.872 12.53h3.672v-6.165c0-.334.022-.668.111-.89.267-.668.868-1.336 1.892-1.336 1.335 0 1.847 1.002 1.847 2.493v5.898h3.672v-6.32c0-3.384-1.802-4.964-4.228-4.964-1.98 0-2.849 1.113-3.338 1.87h.022V12.15h-3.65c.045 1.024 0 11.017 0 11.017Z",
                  fill: "#fff"
                })]
              })
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(es_TelegramShareButton, {
              url: item["link"],
              className: "flex items-center cursor-pointer",
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
                width: "30",
                height: "30",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
                  d: "M30 15c0 8.279-6.699 15-15 15-8.279 0-15-6.699-15-15C0 6.721 6.699 0 15 0s15 6.699 15 15Z",
                  fill: "#3D8ECD"
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
                  d: "M12.26 21.854c-.489 0-.4-.178-.578-.645l-1.424-4.696 8.835-5.52 1.046.268-.868 2.359-7.01 8.234Z",
                  fill: "#B3B3B3"
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
                  d: "M12.262 21.855c.378 0 .534-.178.756-.379.334-.311 4.496-4.362 4.496-4.362l-2.56-.623-2.38 1.491-.312 3.74v.133Z",
                  fill: "gray"
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
                  d: "m12.507 18.049 6.054 4.451c.69.378 1.18.178 1.357-.645l2.47-11.595c.245-1.002-.378-1.47-1.045-1.158L6.899 14.666c-.98.4-.98.957-.178 1.18l3.717 1.157 8.59-5.408c.4-.245.779-.111.467.156l-6.988 6.298Z",
                  fill: "#fff"
                })]
              })
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(es_TwitterShareButton, {
              url: item["link"],
              className: "flex items-center cursor-pointer",
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
                width: "30",
                height: "30",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
                  d: "M15 30c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15C6.716 0 0 6.716 0 15c0 8.284 6.716 15 15 15Z",
                  fill: "#3D8ECD"
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
                  d: "M24.367 10.771a7.293 7.293 0 0 1-1.958.534 3.33 3.33 0 0 0 1.49-1.891 6.88 6.88 0 0 1-2.158.823 3.392 3.392 0 0 0-2.492-1.068c-1.892 0-3.428 1.536-3.428 3.405 0 .267.022.534.09.779a9.662 9.662 0 0 1-7.033-3.56 3.467 3.467 0 0 0-.468 1.713c0 1.18.601 2.225 1.514 2.848a3.691 3.691 0 0 1-1.558-.422v.044c0 1.647 1.18 3.027 2.737 3.36-.29.09-.579.112-.89.112-.223 0-.445-.022-.646-.067a3.453 3.453 0 0 0 3.183 2.381 6.924 6.924 0 0 1-4.25 1.47c-.268 0-.557-.023-.824-.045a9.605 9.605 0 0 0 5.23 1.535c6.276 0 9.725-5.207 9.725-9.725v-.445a6.946 6.946 0 0 0 1.736-1.78Z",
                  fill: "#fff"
                })]
              })
            })
          })]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "rounded-lg shadow overflow-hidden",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
          className: "w-full",
          src: item["img"],
          alt: "press"
        })
      }), item["link"] && item["linkSource"] && /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        className: "text-gray-50 text-xs font-semibold",
        children: ["Source", " ", /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
          href: item["link"],
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            target: "_blank",
            rel: "noreferrer",
            className: "text-primary underline",
            children: item["linkSource"]
          }, "1")
        })]
      }), children]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "w-full h-full",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "px-8 bg-wrapper text-white flex flex-col items-center justify-center space-y-12 pt-10 pb-10",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(ContactUsForm/* default */.Z, {})
      })
    })]
  });
}

/* harmony default export */ var landing_Press = (Press);

/***/ }),

/***/ 48379:
/***/ (function(module) {

module.exports = JSON.parse('[{"name":"datamynt-alibaba","date":"November 9, 2022","author":"DataMynt Team","heading":"Data Mynt and Alibaba Cloud Announce Partnership to Accelerate Crypto and Cloud Adoption in Africa and Latin America","img":"/datamynt-alibaba.png","desc":"The partnership includes three parts: first, enabling Alibaba Cloud customers to pay for their Cloud services using Data Mynt’s crypto as currency option; second, listing and selling Data Mynt services to Cloud customers on Alibaba [...]","link":"https://www.datamynt.com/press/datamynt-alibaba","linkSource":"DataMynt"},{"name":"datamynt-customers","date":"November 1, 2022","author":"DataMynt Team","heading":"Data Mynt’s Announces Its 500th Business Customer is Accepting and Sending Crypto as Currency","img":"/datamynt-customers.png","desc":"Since launching its crypto as currency solutions for businesses, Data Mynt has enabled its 500th customer, an IHG (Intercontinental Hotels Group) property in Mexico City, to accept payments from millions of crypto customers and [...]","link":"https://www.datamynt.com/press/datamynt-customers","linkSource":"DataMynt"},{"name":"datamynt-yellowcard","date":"September 27, 2022","author":"DataMynt Team","heading":"Data Mynt Partners with Yellow Card Financial to Enable Cash Payouts and Digital Asset Services for Merchants Across Africa","img":"/datamynt-yellowcard.png","desc":"Data Mynt’s strategic partnership with Yellow Card Financial allows merchants and platforms across Africa to accept and send payments in digital assets in person and online, settle immediately, and now withdraw funds directly [...]","link":"https://www.datamynt.com/press/datamynt-yellowcard","linkSource":"DataMynt"},{"name":"datamynt-solana","date":"September 2, 2022","author":"DataMynt Team","heading":"Data Mynt’s Digital Asset Payment and Checkout Solution is Live for the Solana Ecosystem (SOL)","img":"/datamynt-solana.png","desc":"Data Mynt’s integration of the Solana Blockchain (SOL) will allow millions of SOL holders to use Solana for cryptocurrency payments around the world at any Data Mynt merchant location [...]","link":"https://www.datamynt.com/press/datamynt-solana","linkSource":"DataMynt"},{"name":"datamynt-airtm","date":"August 25, 2022","author":"DataMynt Team","heading":"Data Mynt Partners with Airtm to Enable Cash Payouts for Merchants and Platforms Across Latin America","img":"/datamynt-airtm.png","desc":"Data Mynt’s strategic partnership with Airtm allows Data Mynt sellers and platforms across Latin America to accept payments in digital assets in person and online, settle immediately, and now withdraw funds directly into their Airtm [...]","link":"https://www.datamynt.com/press/datamynt-airtm","linkSource":"DataMynt"},{"name":"datamynt-mpos","date":"June 29, 2022","author":"DataMynt Team","heading":"Data Mynt Stable Crypto Mobile Point of Sale (mPOS) Android App Live & Available for Download on Google Play Store","img":"/datamynt-ios.png","desc":"Merchants may now download and use Data Mynt’s Stable Crypto Mobile Point of Sale (mPOS) Android App on Google Play Store today to get paid by their customers instantly for higher margins; higher order values; and attracting new customers [...]","link":"https://www.datamynt.com/press/datamynt-mpos","linkSource":"DataMynt"},{"name":"datamynt-polygon","date":"June 29, 2022","author":"DataMynt Team","heading":"Polygon Makes Strategic Investment in Stable Cryptocurrency Checkout & Payment Protocol Data Mynt","img":"/datamxpolygon.png","desc":"The investment & integration streamlines adoption of Data Mynt’s stable crypto checkout and payment protocol globally on the Polygon network for merchants and metaverse builders alike [...]","link":"https://www.datamynt.com/press/datamynt-polygon","linkSource":"DataMynt"},{"name":"datamynt-ios","date":"June 15, 2022","author":"DataMynt Team","heading":"Data Mynt Launches Stable Crypto Mobile Point of Sale for North American Merchants on Apple iOS","img":"/datamynt-ios.png","desc":"Merchants in North America can now download Data Mynt’s Crypto Mobile Point of Sale (mPOS) to get paid by their crypto customers instantly with no volatility, no declines, and 80% less costs versus card payments [...]","link":"https://www.datamynt.com/press/datamynt-ios","linkSource":"DataMynt"},{"name":"datamynt-binance","date":"June 07, 2022","author":"DataMynt Team","heading":"Data Mynt Stable, Omni-Chain Merchant Payment Checkout Solution is Live on Binance Chain (BNB)","img":"/datamynt-binance.png","desc":"Data Mynt’s integration of Binance Chain (BNB), formerly Binance Smart Chain (BSC) in addition to enabling BNB and BUSD coins allows all owners of BNB-enabled wallets [...]","link":"https://www.datamynt.com/press/datamynt-binance","linkSource":"DataMynt"},{"name":"lightning-network","date":"April 11, 2022","author":"DataMynt Team","heading":"Data Mynt Crypto Payment Processing Gateway Now Live On Bitcoin Lightning Network","img":"/dm_ln.png","link":"https://www.datamynt.com/press/lightning-network","desc":"Lightning Network now gives Data Mynt merchants, partners and their customers a faster option for Bitcoin transactions at minimal cost."},{"name":"presswire-bitcoin","date":"April 5, 2022","author":"DataMynt Team","heading":"Data Mynt Payment Processing Platform Now Supports Bitcoin Payments","img":"/datamyntxbitcoin.jpg","desc":"Data Mynt merchants, partners and their customers can now engage in transactions using the world’s first and best-known decentralized digital currency. [...]","link":"https://www.einnews.com/pr_news/567535868/data-mynt-payment-processing-platform-now-supports-bitcoin-payments","linkSource":"EIN Presswire"},{"name":"presswire-polygon","date":"March 17, 2022","author":"DataMynt Team","heading":"The Data Mynt Crypto Payment Processing Platform is Live on the Polygon Network","img":"/datamxpolygon.png","desc":"Data Mynt integration with Polygon enables Ethereum scaling and rapid blockchain payments for merchants, partners and their consumers. [...]","link":"https://www.einpresswire.com/article/565770248/the-data-mynt-crypto-payment-processing-platform-is-live-on-the-polygon-network","linkSource":"EIN Presswire"},{"name":"presswire","date":"March 10, 2022","author":"DataMynt Team","heading":"New Data Mynt Crypto Payment Processing Platform Gives Merchants Simple, Stable Crypto Payments","img":"/payment.jpg","desc":"Retailers and enterprises now have a simple, stable way to adopt crypto payments using the new crypto payment processing solution from Data Mynt, a recognized provider of cryptocurrency payment products [...]","link":"https://www.einpresswire.com/article/565125848/new-data-mynt-crypto-payment-processing-platform-gives-merchants-simple-stable-crypto-payments?r=padmysCPPxBIz9Qt3k","linkSource":"EIN Presswire"}]');

/***/ })

}]);